import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  children: any;
  to: string;
  blank?: boolean;
  className?: string;
  forceHtmlLink?: boolean;
}

export const AtomsLink = (props: Props) => {
  const { children, to, blank, className, forceHtmlLink } = props;

  if (to.startsWith('/') && !forceHtmlLink) {
    return (
      <Link to={to} className={className}>
        {children}
      </Link>
    );
  }

  const target = blank ? '_blank' : '_self';
  return (
    <a href={to} target={target} className={className}>
      {children}
    </a>
  );
};
